import { useState, useEffect } from 'react';

export default function Hero() {
  const [currentSlide, setCurrentSlide] = useState(0);
  
  const slides = [
    'https://static.readdy.ai/image/ee4ab35536c43b833838f71f4d3b75cf/27747a1afe77cad21bc1496d7a494c3d.png',
    'https://static.readdy.ai/image/ee4ab35536c43b833838f71f4d3b75cf/3259618a0f4b6c8d2354253e7461b658.jpeg',
    'https://static.readdy.ai/image/ee4ab35536c43b833838f71f4d3b75cf/bde454667f9e35e50d893a878aea1e33.jpeg'
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  return (
    <section className="relative min-h-[90vh] flex items-center justify-center overflow-hidden">
      {slides.map((slide, index) => (
        <div
          key={index}
          className={`absolute inset-0 transition-opacity duration-1000 ${
            index === currentSlide ? 'opacity-100' : 'opacity-0'
          }`}
        >
          <img 
            src={slide} 
            alt={`The Joy School Paulínia ${index + 1}`}
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-slate-900/80 via-slate-800/70 to-transparent"></div>
        </div>
      ))}

      <div className="relative z-10 max-w-7xl mx-auto px-4 py-20 text-white">
        <div className="max-w-3xl">
          {/* Banner de Matrículas com efeitos especiais */}
          <div className="mb-8 relative">
            <div className="bg-gradient-to-r from-red-500 via-red-600 to-red-700 px-8 py-4 rounded-full inline-block relative overflow-hidden shadow-2xl animate-pulse">
              <div className="absolute inset-0 bg-gradient-to-r from-yellow-400/20 via-transparent to-yellow-400/20 animate-ping"></div>
              <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/10 to-transparent animate-bounce"></div>
              <h3 className="text-2xl md:text-3xl font-black text-white relative z-10 animate-bounce">
                ✨ MATRÍCULAS ABERTAS 2026 ✨
              </h3>
            </div>
            <div className="absolute -top-2 -right-2 w-6 h-6 bg-yellow-400 rounded-full animate-ping"></div>
            <div className="absolute -bottom-2 -left-2 w-4 h-4 bg-yellow-300 rounded-full animate-ping" style={{ animationDelay: '0.5s' }}></div>
          </div>

          <h2 className="text-xl md:text-2xl font-semibold mb-4 text-yellow-300 animate-fade-in">
            The Joy School Paulínia
          </h2>
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold mb-6 leading-tight animate-fade-in-up">
            Escola infantil referência em educação bilíngue
          </h1>
          <p className="text-lg md:text-xl mb-8 leading-relaxed max-w-2xl animate-fade-in-up" style={{ animationDelay: '0.2s' }}>
            Mais que uma escola, um lar para mentes brilhantes. Aqui o futuro do seu filho floresce em dois idiomas e infinitas possibilidades.
          </p>
          <a 
            href="https://wa.me/5519989250972?text=Olá,%20vi%20o%20site%20e%20gostaria%20de%20mais%20informações%20sobre%20as%20matrículas%202026%20na%20The%20Joy%20School%20Paulínia."
            className="inline-block bg-gradient-to-r from-red-500 to-red-600 text-white px-8 py-4 rounded-full font-bold text-lg hover:from-red-600 hover:to-red-700 transition-all transform hover:scale-105 shadow-2xl animate-fade-in-up whitespace-nowrap cursor-pointer"
            style={{ animationDelay: '0.4s' }}
          >
            Garanta sua Vaga 2026!
          </a>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-red-50 to-transparent z-10"></div>

      {/* CSS personalizado para animações */}
      <style jsx>{`
        @keyframes fade-in {
          from { opacity: 0; transform: translateY(20px); }
          to { opacity: 1; transform: translateY(0); }
        }
        
        @keyframes fade-in-up {
          from { opacity: 0; transform: translateY(30px); }
          to { opacity: 1; transform: translateY(0); }
        }
        
        .animate-fade-in {
          animation: fade-in 1s ease-out;
        }
        
        .animate-fade-in-up {
          animation: fade-in-up 1s ease-out;
        }
      `}</style>
    </section>
  );
}
